export default __webpack_public_path__ + "static/media/world_icon.a6a29796.png";